module.exports = __webpack_public_path__ + "media/assets/images/blog/IMG_IMPACT2030-2a18ccc0d0aabfb2f292c1a1df71f654.png";